if (!customElements.get('marika-shipping-crosssell-init')) {
  document.querySelectorAll('[data-marika-shipping-bar]').forEach((bar) => {
    const fill = bar.querySelector('[data-marika-shipping-fill]');
    const thresholdCents = parseInt(bar.dataset.thresholdCents, 10) || 0;

    const updateFromCart = (cart) => {
      if (!thresholdCents) return;
      const percent = Math.min(100, Math.round((cart.total_price / thresholdCents) * 100));
      fill.style.width = percent + '%';
    };

    fetch(window.Shopify ? `${window.Shopify.routes.root}cart.js` : '/cart.js')
      .then((response) => response.json())
      .then(updateFromCart)
      .catch(() => {});

    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => {
        fetch(window.Shopify ? `${window.Shopify.routes.root}cart.js` : '/cart.js')
          .then((response) => response.json())
          .then(updateFromCart)
          .catch(() => {});
      });
    }
  });

  document.querySelectorAll('[data-marika-crosssell]').forEach((carousel) => {
    const track = carousel.querySelector('[data-marika-crosssell-track]');
    const prev = carousel.querySelector('[data-marika-crosssell-prev]');
    const next = carousel.querySelector('[data-marika-crosssell-next]');
    if (!track) return;

    const scrollByCard = (direction) => {
      const card = track.querySelector('.marika-crosssell__item');
      const amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', () => scrollByCard(-1));
    if (next) next.addEventListener('click', () => scrollByCard(1));
  });
}
